import {Application} from "../../model/Application";
import {Assessment} from "../../model/Assessment";
import {CreatePrecedentRequest} from "../../model/CreatePrecedentRequest";
import {ExternalUnitSearchRequest} from "../../model/ExternalUnitSearchRequest";
import {LoadingService} from "../../loading/loading.service";
import {CparService} from "../../cpar/cpar.service";
import * as angular from "angular";
import {ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import "./create-precedent-modal.less";
import {ApplicationService} from "../../application/application.service";
import {CPARSearchRequest} from "../../model/CPARSearchRequest";
import moment = require("moment");

class CreatePrecedentModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public form: any;
    public showErrors: boolean;

    public application: Application;
    public assessment: Assessment;
    public institution: any;

    public createPrecedentRequest: CreatePrecedentRequest = new CreatePrecedentRequest();
    public searchExternalUnitRequest: ExternalUnitSearchRequest = new ExternalUnitSearchRequest();
    private createNewExternalUnit: boolean;
    private processing: boolean;
    private popupStartDate = {opened: false};
    private popupEndDate = {opened: false};
    private popupReviewDate = {opened: false};
    private popupValidityStartDate = {opened: false};
    private popupValidityEndDate = {opened: false};

    private dateOptions = {
        formatYear: "yy",
        minDate: new Date(),
        startingDay: 1
    };

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService,
                private cparService: CparService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.assessment = this.resolve.assessment;
        // if (this.assessment.createdPrecedentId && this.assessment.createdPrecedentId !== "") {
        //     this.fetchPrecedentInfo(this.assessment.createdPrecedentId);
        // }


        this.createPrecedentRequest.credits = this.assessment.credits;
        this.createPrecedentRequest.priorCourseUnits = this.assessment.priorCourseUnits;
        this.createPrecedentRequest.facaultyCode = this.application.owningFacultyCode;

        this.assessment.priorCourseUnits.forEach((unit) => {
            unit.matchedUnitTitle = unit.unitTitle;
            unit.matchedUnitCode = unit.unitCode;
        });
    }

    public searchExternalUnit(searchTerm, unit) {
        this.searchExternalUnitRequest.externalInstId = unit.institutionCode;
        this.searchExternalUnitRequest.externalUnitTitle = searchTerm;
        return this.cparService.searchExternalUnit(this.searchExternalUnitRequest);
    }

    private submit() {
        this.$log.info("submit() %o", this.form);
        if (this.form.$invalid) {
            this.showErrors = true;

            this.toaster.pop({type: "error", title: "Please provide all required information before proceeding."});
            return;
        }
        this.loadingService.show();
        this.processing = true;
        this.cparService.createPrecedent(this.createPrecedentRequest)
            .then((createdPrecedent) => {
                this.$log.debug("submitted new precedent:", createdPrecedent);
                this.toaster.pop({
                    type: "success", title: `Precedent ${createdPrecedent.precedentId} created successfully`
                });
                this.assessment.createdPrecedentId = createdPrecedent.precedentId;
                this.assessment.precedentId = createdPrecedent.precedentId;
                this.applicationService.saveAssessment(this.application, this.assessment).then((assessment) => {
                    this.assessment = assessment;
                    this.close();
                });
            })
            .catch((reason) => {
                this.$log.debug("Failed to create a precedent", reason);
                if (reason.data && reason.data.message) {
                    const regexString = "A invalid response of status \\d{3} was returned:";
                    const regex = new RegExp(regexString, "g");
                    const result = reason.data.message.replace(regex, "");
                    const errorMessageObject = angular.fromJson(result);
                    this.toaster.pop({type: "failure", title: "Failed to create a precedent: " + errorMessageObject.errorDetails.message});
                } else {
                    this.toaster.pop({type: "failure", title: "Failed to create a precedent"});
                }
            })
            .finally(() => {
                    this.processing = false;
                    this.loadingService.hide();
                }
            );
    }

    private cancel() {
        this.dismiss({$value: "cancel"});
    }

    private openStartDate() {
        this.popupStartDate.opened = true;
    }

    private openEndDate() {
        this.popupEndDate.opened = true;
    }

    private openReviewDate() {
        this.popupReviewDate.opened = true;
    }

    private openValidityStartDate() {
        this.popupValidityStartDate.opened = true;
    }

    private openValidityEndDate() {
        this.popupValidityEndDate.opened = true;
    }

    private validateUnits() {
        let isValid = true;
        this.assessment.priorCourseUnits.forEach((unit) => {
            const invalid = unit.externalUnitId === undefined || unit.externalUnitId === null;
            if (invalid) {
                isValid = false;
            }
        });
        return isValid;
    }

    private onSelectedExternalUnit($item, $model, $label, $event, unit) {
        this.$log.debug("onSelectedExternalUnit $item: %o, $model: %o, $label: %o, $event: %o", $item, $model, $label, $event);
        if ($item.id === -1) {
            this.createNewExternalUnit = true;
            unit.willCreate = true;
        } else {
            unit.externalUnitId =  $item.id;
            unit.unitCode = $item.unitCode;
            unit.unitTitle = $item.title;
        }
    }

    private fetchPrecedentInfo(createdPrecedentId: string) {
        const cparPrecedentSearchRequest = new CPARSearchRequest();
        cparPrecedentSearchRequest.precedentId = createdPrecedentId;
        this.cparService.searchCPARPrecedents(cparPrecedentSearchRequest).then((results: any) => {
            const cparSearchResponse = results;
            if (cparSearchResponse._embedded.items.length > 0) {
                const precedent = cparSearchResponse._embedded.items[0];
                this.$log.log("Fetched existing precedent: %o", precedent);
                this.searchExternalUnitRequest.externalUnitTitle = precedent.externalUnits[0].title;
               // this.createPrecedentRequest.externalUnitId = precedent.externalUnits[0].id;
                this.createPrecedentRequest.approvedBy = precedent.approvedBy;
                this.createPrecedentRequest.validityPeriodStartDate = moment(precedent.validityPeriodStartDate).toDate();
                this.createPrecedentRequest.validityPeriodEndDate = moment(precedent.validityPeriodEndDate).toDate();
            }
        });
    }
}

export const CreatePrecedentModalComponent: angular.IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "=",
        close: "&",
        dismiss: "&"
    },
    controller: CreatePrecedentModalController,
    template: require("./create-precedent-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/create-precedent-modal/create-precedent-modal.component.ts